export enum ButtonTypes {
  None = 'none',
  Private = 'private',
  Extension = 'extension',
  Park = 'park',
  Login = 'login',
  Flag = 'flag',
  Speed = 'speed',
  HuntGroup = 'hunt',
  AgentGroup = 'queue',
}
